export default __webpack_public_path__ + "static/Willem_Arnoldusse_3-23f55bf45cf0760e346c8d0b047c2204.jpg";